import { Component, OnDestroy, OnInit, TemplateRef, ViewChild, ElementRef } from '@angular/core';
import { NbMediaBreakpointsService, NbMenuService, NbSidebarService, NbThemeService } from '@nebular/theme';
import { Router } from '@angular/router';
import { UserData } from '../../../@core/data/users';
import { map, filter, takeUntil, takeWhile } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { NbDialogService } from '@nebular/theme';
import { AuthService } from '../../../services/auth.service';
import { ActiveUserService } from '../../../services/active-user.service';
import { UserWithPrivilege } from '../../../models/user-modal';
import { SessionService } from '../../../services/helper/session.service';
import { faCheck, faCircle, faEllipsisH, faTimes } from '@fortawesome/free-solid-svg-icons';
import { MainService } from '../../../services/main.service';
import { NotifierService } from '../../../services/helper/notifier.service';

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {
  userInfo: UserWithPrivilege
  isAlive: boolean;
  faCheck = faCheck;
  faTimes = faTimes;
  faCircle = faCircle;
  notification: any;
  notificationContainer: any;
  faEllipsisH = faEllipsisH;
  @ViewChild('dropdown', {static: true}) notificationDropdown: any
  unreadNotification: any;
  private readonly destroy$: Subject<void> = new Subject<void>();
  userPictureOnly: boolean = false;
  user: any;
  themes = [
    // {
    //   value: 'default',
    //   name: 'Light',
    // },
    {
      value: 'dark',
      name: 'Dark',
    },
    {
      value: 'cosmic',
      name: 'Cosmic',
    },
    {
      value: 'corporate',
      name: 'Corporate',
    },
  ];
  currentTheme = 'default';


  userMenu = [{ title: 'Change Password' }

  ];


  constructor(
    private readonly sidebarService: NbSidebarService,
    private readonly menuService: NbMenuService,
    private readonly themeService: NbThemeService,
    private readonly userService: UserData,
    private readonly breakpointService: NbMediaBreakpointsService,
    private readonly dialogService: NbDialogService,
    private readonly router: Router,
    private readonly _AuthService: AuthService,
    private readonly _ActiveUserService: ActiveUserService,
    private readonly _SessionService: SessionService,
    private readonly _MainService: MainService,
    private readonly _NotifierService: NotifierService,
  ) {
    this.userInfo = new UserWithPrivilege();
    this.isAlive = true;
    this.notificationContainer = [];
  }


  ngOnInit() {
    this._ActiveUserService.getLogedUser().pipe(takeWhile(() => this.isAlive)).subscribe(value => {
      this.userInfo = value;
      this.getNotificationData();
    })
    this.currentTheme = this.themeService.currentTheme;
    this.menuService.onItemClick()
      .pipe(
        filter(({ tag }) => tag === 'profileMenu'),
        map(({ item: { title } }) => title),
      )
      .subscribe(title => {
        if (title === 'Change Password') {
          this.router.navigate(['admin/update-password'])
        }


      });




    this.userService.getUsers()
      .pipe(takeUntil(this.destroy$))
      .subscribe((users: any) => this.user = users.nick);

    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);

    this.themeService.onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => this.currentTheme = themeName);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.isAlive = false;
  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');

    return false;
  }

  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }


  profile() {

  }
  logOut() {
    const email = this._SessionService.getSession('email');
    this._AuthService.logOut({ email: email }, 'header').then(data => data)
    this.router.navigate(["auth/login"]);
  }


  openDialog(dialog: TemplateRef<any>) {
    this.dialogService.open(dialog, { context: 'Are you sure you want to logout ?' });
  }

  // notification
  openPop(event: any, pop: any) {
    event.stopPropagation();
    pop.toggle()
  }

  getNotificationIcon(notificationId: any) {
    if (notificationId === 1) {
      return `/assets/img/Like.svg`
    } else if (notificationId === 2) {
      return `/assets/img/Comment.svg`
    } else if (notificationId === 3) {
      return `/assets/img/Subscribe.svg`
    } else if (notificationId === 4) {
      return `/assets/img/upload-icon.svg`
    }
    else {
      return `/assets/img/Schedule.svg`
    }

  }
  deleteNotification(id: any) {
    let body = {};
    if (id === 0) {
      body = {
        id: id,
        userId: this.userInfo.user.id
      }
    } else {
      body = {
        id: id
      }
    }

    this._MainService.deleteNotification(body, 'header').then((data) => {
      if (data.isSuccess) {
        this.notificationContainer.forEach((val: any) => {
          if (id === 0) {
            this.notificationContainer = []
          } else {
            val.data.forEach((value: any, index: any, array: any) => {
              if (value.id === id) {
                array.splice(index, 1);
              }
            });
          }
        })
        this._NotifierService.showSuccess(data.message)
      } else {
        this._NotifierService.showError(data.message);
      }
    })

  }

  readNotification(id: any) {
    const body = {
      id: id
    }
    this._MainService.readNotification(body, 'header').then(data => {
      this.getNotificationData();
    })
  }
  getNotificationData() {
    this.notificationContainer = [];
    this._MainService.getNotification(this.userInfo.user.id,1, 'header').then(data => {
      if (data && data.isSuccess) {
        this._MainService.getcountUnreadNotifications(this.userInfo.user.id, 'header').then(data => {
          if (data.isSuccess) {
            this.unreadNotification = data.data.unreadNotifications;
          }
        })
        this.notification = data.data
        for (let key in this.notification) {
          const modifydata: any = {
            date: key,
            data: this.notification[key]
          }
          this.notificationContainer.push(modifydata)
        }
      }
    })
  }


}
